import { Helmet } from '@dr.pogodin/react-helmet';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { css, html } from 'react-strict-dom';

import { Api } from '../../api';
import {
  PageError,
  PageHeading,
  PageLoading,
  PageWrap,
  Pagination,
  Spacer,
  Text,
} from '../../components';
import { useSelectedCompany } from '../../contexts/ClientDataContext';
import { useMyUserClient } from '../../hooks';
import CreateReleaseForm from './CreateReleaseForm';
import ReleaseDetail from './ReleaseDetail';

export default function ReleasePage() {
  const { pathname, search } = useLocation();
  const company = useSelectedCompany();
  const myUser = useMyUserClient();

  const searchParams = new URLSearchParams(search);
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [search]);

  const api = Api.Release.useReadCollectionListCompanySub(company.id, {
    page: searchParams.has('page')
      ? parseInt(searchParams.get('page') ?? '', 10)
      : 1,
  });
  const releases = api.data?.['hydra:member'];
  if (api.error) return <PageError {...api} />;
  if (!releases) return <PageLoading />;

  return (
    <PageWrap limitWidth="small">
      <Helmet>
        <title>Releases | {company.name}</title>
      </Helmet>

      <PageHeading>Releases</PageHeading>

      {myUser.agencyRole && (
        <>
          <CreateReleaseForm
            companyId={company.id}
            invalidate={api.invalidate}
          />
          <Spacer />
        </>
      )}

      {releases.length === 0 ? (
        <Text as="p" style={styles.emptyText}>
          No releases yet
        </Text>
      ) : (
        releases.map((release) => (
          <html.div key={release['@id']}>
            <ReleaseDetail
              release={release}
              listView
              invalidate={api.invalidate}
            />
            <html.hr style={styles.divider} />
          </html.div>
        ))
      )}

      {api.data && (
        <Pagination
          hydraCollection={api.data}
          pageUrl={(n) => `${pathname}?page=${n}`}
        />
      )}
    </PageWrap>
  );
}

const styles = css.create({
  emptyText: {
    marginBlock: '1em',
  },
  divider: {
    height: 1,
    borderWidth: 0,
    backgroundColor: '#ddd',
    marginBlock: 50,
  },
});
